import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

import indonesiaGeoJSON from '../indonesia-province-simple.json';
import { offset } from "@popperjs/core";

let popupGroup;

function mapPortfolio() {
    const indonesiaMap = indonesiaGeoJSON;

    // init
    const map = L.map('map', {
        center: [-2.569834, 118.165100],
        zoom: 5,
        zoomControl: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
    });
    map.dragging.disable();

    // map zoom control
    L.control.zoom({
        position: 'bottomleft',
    }).addTo(map);

    // map background
    L.tileLayer('').addTo(map);

    // map style
    const style = {
        "color": "white",
        "weight": "2",
        "fillColor": "#6A6A6A",
        "fillOpacity": '0.5'
    };
    const indonesiaMapGeoJSON = L.geoJSON(indonesiaGeoJSON, {
        style: style,
    }).addTo(map);

    popupGroup = L.layerGroup();
    popupGroup.addTo(map);

    // map pin
    const customIcon = L.divIcon({
        className: 'map__marker',
        html: '<span class="map__marker-waves"><span></span></span>'
    });

    const portfolioSelect = document.querySelector('.portfolio__location-select');
    const portfolioForm = document.querySelector('#portfolio-filter');
    let locationMap = locationMapJson;
    locationMap.forEach((e) => {
        let slug = e.slug;
        let name = e.name;
        let className = name.replace(/ /g, '-');
        let latitude = e.latitude;
        let longitude = e.longitude;

        if(latitude || longitude != null) {
            let currentMarker = L.marker([latitude, longitude], {
                icon: customIcon,
            }).addTo(map);
        
            currentMarker.on("mouseover", (e) => {

                const exist = popupGroup.getLayers().find( item => item.id == name );

                if ( !exist ) {

                    let myPopup = L.popup({
                        autoPan: false,
                        maxWidth: 120,
                        className: "custom-popup",
                        content: `<span class="map__pin ${className}">${name}</span>`,
                    }).setLatLng(e.latlng);

                    myPopup.id = name;

                    myPopup.addTo(popupGroup);
                }

                let popupContainer = document.querySelector(`.map__pin.${className}`).parentNode.parentNode.parentNode;
                popupContainer.style.height = '76px';
                popupContainer.style.opacity = '1';
            })
            .on('mouseout', () => {
                
                let popupContainer = document.querySelector(`.map__pin.${className}`).parentNode.parentNode.parentNode;
                popupContainer.style.height = '0px';
                popupContainer.style.opacity = '0';
            })
            .on('click', () => {
                portfolioSelect.value = slug;
                portfolioForm.submit();
            })
        }
    })
}

function portfolioFilter() {
    const portfolioForm = document.querySelector('#portfolio-filter');
    let portfolioLocationSelect = document.querySelector('#selectLocation');
    let selectedMaterialValue = document.querySelectorAll('input[name="material"]'); 

    jQuery(function($) {
        $('#selectLocation').selectpicker();
    });
    
    portfolioLocationSelect.addEventListener("change", function(event){
        portfolioForm.submit();
    });

    selectedMaterialValue.forEach((item) => {
        item.addEventListener("change", () => {
            portfolioForm.submit();
        })
    })
    
    let checkedRadioLabel = document.querySelector('input[name="material"]:checked');
    let materialFilterPlaceholder = checkedRadioLabel.getAttribute('data-name');
    const materialButton = document.querySelector('.portfolio__material-button span');
    materialButton.innerText = materialFilterPlaceholder;
}

function materialSelect() {
    const portfolioForm = document.querySelector('.portfolio__filter');
    const materialButton = document.querySelector('.portfolio__material-button');
    const materialOverlay = document.querySelector('.portfolio__overlay');

    materialButton.addEventListener('click', (e) => {
        e.preventDefault();
        
        portfolioForm.classList.toggle('show');
        e.target.classList.toggle('show');
    })

    materialOverlay.addEventListener('click', (e) => {        
        portfolioForm.classList.remove('show');
        materialButton.classList.remove('show');
    })
}

function modalPortfolio() {
    // get data gallery attribute
    const portfolioItems = document.querySelectorAll('.portfolio-card__item');
    let modalImageWrapper = document.querySelector('.modal-portfolio__swiper .swiper-wrapper');

    portfolioItems.forEach((item) => {
        item.addEventListener("click", (e) => {
            const portfolioModalSwiper = new Swiper(".modal-portfolio__swiper", {
                modules: [ Pagination, Navigation ],
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".modal-portfolio__button-next",
                    prevEl: ".modal-portfolio__button-prev",
                }
            });

            let portfolioItemID = e.target.getAttribute('data-portfolio');

            // select modal element
            let modalTitle = document.querySelector('.modal-portfolio__title');
            let modalDescription = document.querySelector('.modal-portfolio__description');
            let modalClient = document.querySelector('.modal-portfolio__value.client');
            let modalMaterial = document.querySelector('.modal-portfolio__value.material');
            let modalYear = document.querySelector('.modal-portfolio__value.year');
            let modalLocation = document.querySelector('.modal-portfolio__value.location');

            // get portfolio value
            let imageSwiper = portfolioJson[portfolioItemID].images;
            let title = portfolioJson[portfolioItemID].title;
            let client = portfolioJson[portfolioItemID].client;
            let material = portfolioJson[portfolioItemID].material;
            let year = portfolioJson[portfolioItemID].year;
            let location = portfolioJson[portfolioItemID].location;
            let description = portfolioJson[portfolioItemID].description;
            
            // add value into modal section
            modalTitle.innerHTML = title ? title : '-';
            modalClient.innerHTML = client ? client : '-';
            modalYear.innerHTML = year ? year : '-';
            modalLocation.innerHTML = location ? location : '-';
            modalDescription.innerHTML = description ? `<p>${description}</p>` : `<p>-<p>`;
            
            // modalMaterial.innerHTML = material ? material : '-';
            if(material.length != 0) {
                material.forEach(element => {
                    modalMaterial.innerText = element;
                });
            } else {
                modalMaterial.innerHTML = '-';
            }

            if (imageSwiper) {
                imageSwiper.forEach( (image) => {
                    // add image wrapper element
                    let swiperSlide = document.createElement('div');
                    swiperSlide.className = 'swiper-slide modal-portfolio__item';
    
                    // add image element
                    let swiperImage = document.createElement("img");
                    swiperImage.src = `${image.portfolio_image.url}`;
                    swiperImage.className = 'modal-portfolio__image';
                    swiperImage.alt = `${image.portfolio_image.alt}`;
    
                    // append image into image wrapper
                    swiperSlide.appendChild(swiperImage);
                    
                    // append image wrapper into swiper wrapper
                    modalImageWrapper.appendChild(swiperSlide);
                });
            }
        })
    })

    document.addEventListener('hidden.bs.modal', () => {
        modalImageWrapper.innerHTML = '';
    })
}

document.addEventListener('DOMContentLoaded', () => {
    mapPortfolio();
    portfolioFilter();
    materialSelect();
    modalPortfolio();
})